export default __webpack_public_path__ + "static/media/fb.8832a03a.svg";